import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewsRoutingModule } from './news-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AccomplishmentsComponent } from 'src/app/Components/accomplishments/accomplishments.component';
import { NewsDetailComponent } from 'src/app/Components/accomplishments/news-detail/news-detail.component';
import { EnterpriseModalModule } from '../enterprise-modal/enterprise-modal.module';


@NgModule({
  declarations: [
    AccomplishmentsComponent,
    NewsDetailComponent
  ],
  imports: [
    CommonModule,
    NewsRoutingModule,
    ReactiveFormsModule,
    EnterpriseModalModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class NewsModule { }
